import { atom } from "jotai";
import { CallLibraryStatus, HangUpReasonType } from "~/utils/sip.types";

/** 現在のSIP通話ライブラリステータス */
export const callStatusAtom = atom<CallLibraryStatus>(CallLibraryStatus.none);

/** 通話中かどうか（connect受信〜disconnect受信まで true） */
export const isCallingAtom = atom<boolean>(false);

/** 通話経過時間の表示文字列（例: "01:23"） */
export const callDurationAtom = atom<string>("00:00");

/** 通話終了理由 */
export const hangUpReasonAtom = atom<HangUpReasonType>(HangUpReasonType.other);
